<template>
    <div component="ProjectCreate">
        <v-form :disabled="loading" ref="form" v-model="valid">
            <v-text-field :rules="requiredRule" label="Project name" v-model="project.nazov"></v-text-field>
            <!--            <v-text-field :rules="requiredRule" label="Piece name" v-model="project.piece.nazov"></v-text-field>-->

            <v-select
                :rules="requiredRule"
                :items="formAttributes.types"
                item-text="name"
                item-value="value"
                v-model="project.piece.typ"
                label="Piece type"
            ></v-select>

            <v-select
                :items="formAttributes.seconds"
                item-text="name"
                item-value="value"
                v-model="project.piece.dlzka"
                label="Length in seconds"
            ></v-select>

            <v-select
                :items="formAttributes.territories"
                item-text="name"
                item-value="value"
                v-model="project.piece.teritory"
                label="Territory"
            ></v-select>

            <v-select
                :items="formAttributes.timespans"
                item-text="name"
                item-value="value"
                v-model="project.piece.obdobie"
                label="Timespan"
            ></v-select>
        </v-form>

        <btn :text="'Create new project'" :icon="'add_circle'" @click="validateForm"></btn>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import MenuButton from '@/components/AppHeader/AppHeaderButtons.vue';

export default {
    name: 'ProjectCreate',

    data() {
        return {
            fatalError: false,
            loading: true,
            valid: true,
            requiredRule: [(v) => !!v || 'This field is required'],
            project: {
                piece: {
                    // nazov: '',
                    typ: null,
                    dlzka: 6,
                    teritory: 1,
                    obdobie: 1,
                },
            },
        };
    },

    async mounted() {
        this.loading = false;
    },

    methods: {
        ...mapActions(['storeProject']),
        ...mapMutations(['setSelectedProject']),

        async tryStoreProject() {
            this.loading = true;

            if (this.$route.params && this.$route.params.client_id) {
                this.project.id_klient = this.$route.params.client_id;
                await this.storeProject(this.project);
                this.setSelectedProject(this.getProject.id);
                this.$router.push({ name: 'project-shortlist', params: { project_id: this.getProject.id } });
            }
            this.loading = false;
        },

        validateForm(evt) {
            evt.preventDefault();

            this.$refs.form.validate();
            if (!this.valid) {
                return;
            }

            this.tryStoreProject();
        },
    },

    computed: {
        ...mapGetters({
            formAttributes: 'getProjectFormAttributes',
            getProject: 'getProject',
        }),
    },

    components: {
        MenuButton,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectCreate'] {
    height: 100%;
    flex-direction: column;
    display: flex;
    justify-content: space-between;

    .v-input {
        input {
            border: none !important;
        }
    }
}
</style>
